import ScrollMagic from 'scrollmagic/scrollmagic/uncompressed/ScrollMagic';

import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';

import Header from './header'

const Controller = {
	standby: function () {
		this.imgResponFlag = true;
		this.view = {};
		this.view.window = $(window);
		// this.view.window.on('load scroll', this.scroll.bind(this));
		// this.view.window.on('load resize', this.resize.bind(this));
		// this.view.window.on('load resize:responsive', this.imgRespon.bind(this));
		// this.view.window.on('load', this.loading.bind(this));
		this.view.window.on('scroll', this.scroll.bind(this));
		this.view.window.on('resize', this.resize.bind(this));
		this.view.window.on('resize:responsive', this.imgRespon.bind(this));

		// this.timer = null;
		// this.container = 1366;
		// this.percent = 1;
		// this.view.window.on('load resize', this.scale.bind(this));
		this.loadFlag = true;

		this.view.frame  = $('.site-frame-inner');
		this.view.window.on('load resize', this.setHeight.bind(this));
		this.ScrollController = new ScrollMagic.Controller({refreshInterval: 3000});

		$('.smoothScroll').on('click', this.smoothScroll.bind(this));

		$('.page-top-btn').on('click', this.pageTop.bind(this));

		this.scroll();
		this.resize();
		this.imgRespon();
		this.setHeight();
		this.loading();
	},


	scroll: function () {
		this.view.window.y = this.view.window.scrollTop();
		this.view.window.h = this.view.window.innerWidth;
	},
	resize: function () {
		this.view.window.w = window.innerWidth;
		if (this.view.window.get(0).matchMedia('(max-width: 900px)').matches) {
			if (this.device != 'SP') {
				this.device = 'SP';
				this.view.window.trigger('resize:SP');
				this.view.window.trigger('resize:responsive');
			}
		} else {
			if (this.device != 'PC') {
				this.device = 'PC';
				this.view.window.trigger('resize:PC');
				this.view.window.trigger('resize:responsive');
			}
		}
	},
	imgRespon: function () {
		if (this.device === 'SP') {
			if (this.imgResponFlag) {
				$('img.respon').each(function (index) {
					$(this).attr('src', $(this).attr('src').replace(/^(.+)(\.[a-z]+)$/, '$1' + '.sp' + '$2'));
				});
				this.imgResponFlag = false;
			}
		}
		if (this.device === 'PC') {
			this.imgResponFlag = true;
			$('img.respon').each(function () {
				$(this).attr('src', $(this).attr('src').replace('.sp', ''));
			});
		}
	},
	scrollMagic: function () {
		if (typeof ScrollMagic != 'undefined') {
			var section = document.querySelectorAll('.js-anime:not(.is-active)');
			var controller = this.ScrollController;
			if (section.length != 0) {
				Array.prototype.slice.call(section).forEach(function (sec, index) {
					var anime = new ScrollMagic.Scene({
							triggerElement: sec,
							triggerHook: 'onCenter',
							reverse: false
						})
						//.addIndicators( {name: "scroll"})
						.addTo(controller);
					anime.on('enter', function (event) {
						sec.classList.add('is-active');
					});
					anime.on('end', function () {
						anime.destroy(true);
					})
				});
			}
		}
	},
	smoothScroll: function(el) {
		var className = $(el.currentTarget).data('target');
		var element = document.getElementsByClassName(className);

		if(this.device === 'PC') {

			var position = Math.ceil(window.innerWidth * (300 / 1366));
			var offset = $(element).offset().top - position - 50;

		} else {
			$('.toggle-mark').removeClass('is-active');
			$('.header').removeClass('is-openFixed');
			var H = $('.header').height();

			Header.close();
			var position = Math.ceil(window.innerWidth * (300 / 750));
			var offset = $(element).offset().top - position - H - 50;
		}


		$('body, html').animate({scrollTop: offset}, 300, 'swing');
	},
	setHeight: function() {
		// clearTimeout(this.timer);
		// this.timer = setTimeout(function(){
			var bodyHeight = null;
			if(this.device === 'PC') {
				bodyHeight = Math.ceil(window.innerWidth * (9200 / 1366));
			} else {
				bodyHeight = Math.ceil(window.innerWidth * (15000 / 750));
			}


			this.view.frame.css({'height': bodyHeight});

			// if(this.loadFlag) {
			// 	this.scrollMagic();
			// 	this.loadFlag = false;
			// }

		// }.bind(this),500)
	},
	loading: function() {
		// $('.loading-frame').animate({opacity:1},500,'swing', function(){
		// 	$('.loading-frame .logo-area').animate({opacity: 1},1000,'swing', function(){
		// 		$('.site-frame').addClass('is-show');
		// 		$('.logo-star').addClass('is-active');
		// 		$('.cosmos').addClass('is-active');
		// 		$('.loading-frame .logo-area').delay(3000).animate({opacity: 0}, 500 , 'swing')
		// 		$('.loading-frame').delay(4000).fadeOut(1000);
		// 	});
		// });

		var deferred1 = $.Deferred();
		var deferred2 = $.Deferred();

		// ローディングエリア自体のローディング
		(function() {
			var srcs = [];
			var count = 0;

			$('.loading-frame, .loading-frame *').each(function() {
				var src = '';
				if(this.tagName == 'IMG') {
					src = this.src;
				} else if($(this).css('backgroundImage')) {
					src = $(this).css('backgroundImage').replace(/url\(("|')/, '').replace(/("|')\);?/, '');
				}
				if(src && src.match(/^https?(:\/\/[-_.!~*\'()a-zA-Z0-9;\/?:\@&=+\$,%#]+)$/)) {
					srcs.push(src);
				}
			});
			srcs.forEach(function(src) {
				$('<img>').on('load error', function() {
					if(++count == srcs.length) {
						$('.loading-frame').addClass('is-active');
						$('.logo-star').addClass('is-active');

						setTimeout(function() {
							deferred1.resolve();
						}, 2400);
					}
				}).attr({src : src});
			});
		})();

		// 初期表示に必要なエリアのローディング
		(function() {
			var srcs = [];
			var count = 0;
			var maxy = $(window).scrollTop() + $(window).height();

			$('.site-frame, .site-frame *').each(function() {
				if($(this).is(':visible')) {
					if($(this).offset().top < maxy) {
						var src = '';
						if(this.tagName == 'IMG') {
							src = this.src;
						} else if($(this).css('backgroundImage')) {
							src = $(this).css('backgroundImage').replace(/url\(("|')/, '').replace(/("|')\);?/, '');
						}
						if(src && src.match(/^https?(:\/\/[-_.!~*\'()a-zA-Z0-9;\/?:\@&=+\$,%#]+)$/)) {
							srcs.push(src);
						}
					}
				}
			})
			srcs.forEach(function(src) {
				$('<img>').on('load error', function() {
					if(++count == srcs.length) {
						deferred2.resolve();
					}
				}).attr({src : src});
			});
		})();

		$.when(
			deferred1.promise(),
			deferred2.promise()
		).done(function() {
			$('.site-frame').addClass('is-show');
			$('.cosmos').addClass('is-active');
			$('.loading-frame').addClass('is-inactive');

			setTimeout(function() {
				$('.loading-frame').remove();

				this.scrollMagic();
			}.bind(this), 1500 + 250);
		}.bind(this));
	},

	loadingComplete: function() {

	},

	pageTop: function() {
		$('body,html').animate({scrollTop: 0}, '300', 'swing');
	}
};

export default Controller;
